/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_FullscreenInputs */

const en_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Fullscreen`)
};

const fr_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer en plein écran`)
};

const de_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbildmodus umschalten`)
};

const it_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva schermo intero`)
};

const ru_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить полноэкранный режим`)
};

const es_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar a pantalla completa`)
};

const zh_cn2_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换全屏`)
};

const ja_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面表示を切り替える`)
};

const hi_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपूर्ण स्क्रीन टॉगल करें`)
};

const pt_pt2_toggle_fullscreen = /** @type {(inputs: Toggle_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar tela cheia`)
};

/**
* | output |
* | --- |
* | "Toggle Fullscreen" |
*
* @param {Toggle_FullscreenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_fullscreen = /** @type {((inputs?: Toggle_FullscreenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_FullscreenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toggle_fullscreen(inputs)
	if (locale === "de") return de_toggle_fullscreen(inputs)
	if (locale === "it") return it_toggle_fullscreen(inputs)
	if (locale === "ru") return ru_toggle_fullscreen(inputs)
	if (locale === "es") return es_toggle_fullscreen(inputs)
	if (locale === "zh-CN") return zh_cn2_toggle_fullscreen(inputs)
	if (locale === "ja") return ja_toggle_fullscreen(inputs)
	if (locale === "hi") return hi_toggle_fullscreen(inputs)
	if (locale === "pt-PT") return pt_pt2_toggle_fullscreen(inputs)
	return en_toggle_fullscreen(inputs)
});